import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios";
import axiosInstance from "@/commons/AxiosInstance.ts";
import { ITenantConfig } from "@/services/tenant-service/entities/TenantEntity.ts";

export abstract class HttpClient {
  protected instance: AxiosInstance = axiosInstance;
}

export class HttpClientNormal extends HttpClient {
  private readonly timezone: string;

  constructor() {
    super();
    const tenantConfig: ITenantConfig = JSON.parse(
      localStorage.getItem("tenant_config") || "{}"
    );
    this.timezone = tenantConfig.timezone || "";
  }

  get(url: string, options?: AxiosRequestConfig): Promise<AxiosResponse> {
    let headers: Record<string, string>;
    if (this.timezone) {
      headers = { timezone: this.timezone };
    } else {
      headers = {};
    }
    const optionsCustom: AxiosRequestConfig = {
      ...options,
      headers,
    };
    return this.instance.get(url, optionsCustom);
  }

  post(
    url: string,
    data: object = {},
    cId: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse> {
    let headers: Record<string, string> | any;
    if (this.timezone) {
      headers = {
        cId: cId,
        timezone: this.timezone,
        ...(options?.headers || {}),
      };
    } else {
      headers = { cId: cId, ...(options?.headers || {}) };
    }
    const optionsCustom: AxiosRequestConfig = {
      ...options,
      headers,
    };
    return this.instance.post(url, data, optionsCustom);
  }

  put(
    url: string,
    data: object = {},
    cId: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse> {
    let headers: Record<string, string>;
    if (this.timezone) {
      headers = { cId: cId, timezone: this.timezone };
    } else {
      headers = { cId: cId };
    }
    const optionsCustom: AxiosRequestConfig = {
      ...options,
      headers,
    };
    return this.instance.put(url, data, optionsCustom);
  }

  patch(
    url: string,
    data: object = {},
    cId: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse> {
    let headers: Record<string, string>;
    if (this.timezone) {
      headers = { cId: cId, timezone: this.timezone };
    } else {
      headers = { cId: cId };
    }
    const optionsCustom: AxiosRequestConfig = {
      ...options,
      headers,
    };
    return this.instance.patch(url, data, optionsCustom);
  }

  delete(
    url: string,
    cId: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse> {
    let headers: Record<string, string>;
    if (this.timezone) {
      headers = { cId: cId, timezone: this.timezone };
    } else {
      headers = { cId: cId };
    }
    const optionsCustom: AxiosRequestConfig = {
      ...options,
      headers,
    };
    return this.instance.delete(url, optionsCustom);
  }
}